import { createSlice } from "@reduxjs/toolkit";
import {loginAction, guestLoginAction, registerAction,logoutAction,loginWithGoogleAction,exchangeGoogleHandoffAction,loginWithFacebookAction} from "../actions/authActions";
import { getCookie } from "../../utils/utils";
const initialState={
    token:getCookie("_aps_t"),
    user:getCookie("_aps_u")?JSON.parse(getCookie("_aps_u")):'',
    isLoggedIn:getCookie("_aps_u")?true:false,
}
const authSlice=createSlice({
    name:"auth",
    initialState:initialState,
    reducers:{
        // Merge updated fields into the signed-in user (e.g. after a profile
        // save) so the header name + Profile form reflect changes immediately.
        setUser(state, action){
            state.user = { ...(state.user || {}), ...(action.payload || {}) };
        },
    },
    extraReducers:(builder)=>{
        builder.addCase(loginAction.fulfilled,(state,action)=>{
        state.token=action.payload.token;
        state.user=action.payload.user;
        state.isLoggedIn=true;
        });

        builder.addCase(guestLoginAction.fulfilled,(state,action)=>{
            state.user=action.payload;
            state.isLoggedIn=true;
        });

        builder.addCase(registerAction.fulfilled,(state,action)=>{
            state.token=action.payload.token;
            state.user=action.payload.user;
            state.isLoggedIn=true;
        });

        builder.addCase(logoutAction.fulfilled,(state,action)=>{
            state.isLoggedIn=false;
            state.user='';
            state.token='';
        });

        builder.addCase(loginWithGoogleAction.fulfilled,(state,action)=>{
            state.token=action.payload.token;
            state.user=action.payload.user;
            state.isLoggedIn=true;
        });

        builder.addCase(exchangeGoogleHandoffAction.fulfilled,(state,action)=>{
            state.token=action.payload.token;
            state.user=action.payload.user;
            state.isLoggedIn=true;
        });

        builder.addCase(loginWithFacebookAction.fulfilled,(state,action)=>{
            state.token=action.payload.token;
            state.user=action.payload.user;
            state.isLoggedIn=true;
        });

    }
});
export const { setUser } = authSlice.actions;
export default authSlice.reducer;
